<div>
  <mat-tab-group>
    <mat-tab label="Featured Products">
      <mat-form-field class="pe-se-input">
        <mat-label>Header</mat-label>
        <input matInput
               [(ngModel)]="item.data.header"/>
      </mat-form-field>

      <mat-form-field class="pe-se-input">
        <mat-label>Description</mat-label>
        <textarea matInput
                  [(ngModel)]="item.data.description">
        </textarea>
      </mat-form-field>
      <button mat-raised-button color="accent" class="pe-se-input" (click)="openSelectProducts()">Select Products</button>
    </mat-tab>
    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>
</div>
